// ESM-Huelle fuer lib/scripts/components/CMP_CContainerTable.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CContainerTable (id)
{
    this.construct (id);

    this.name = "CContainerTable";
    this.htmlType = "table";
    
    this.body = null;
    this.properties = 
    {
        rows: 1,
        columns: 1,
        styles: {}
       /* {
            width: "100%",
            height: "100%"
        }*/
    };
}

CContainerTable.prototype = new CComponent;

CContainerTable.prototype.prepare = function ()
{
    this.body = this.addChild (CContainerTableBody);
    this.body.properties.columns = this.properties.columns;
    this.body.properties.rows = this.properties.rows;
    this.body.prepare ();
    
    this.prepared = true;
}

export { CContainerTable };
